import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, Phone, Mail, Calendar, CheckCircle } from "lucide-react";

const CTA = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid-white/10 bg-[size:20px_20px]"></div>
      
      {/* Floating Elements */}
      <div className="absolute top-20 left-10 opacity-20">
        <CheckCircle size={60} className="text-blue-300 animate-pulse" />
      </div>
      <div className="absolute bottom-20 right-10 opacity-20">
        <Calendar size={50} className="text-indigo-300 animate-bounce" />
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
            🚀 Comienza Hoy Mismo
          </div>
          
          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Transforma tu negocio con
            <span className="bg-gradient-to-r from-blue-200 to-white bg-clip-text text-transparent">
              {" "}SAIP
            </span>
          </h2>
          
          <p className="text-xl lg:text-2xl text-blue-100 mb-12 leading-relaxed">
            Únete a más de 1,000 empresas que ya optimizaron sus operaciones. 
            Demo gratuita en 15 minutos, implementación en 24 horas.
          </p>

          {/* Benefits Cards */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <CheckCircle className="text-green-400 mx-auto mb-4" size={48} />
              <h3 className="text-white font-bold text-lg mb-2">Demo Gratuita</h3>
              <p className="text-blue-100 text-sm">
                15 minutos para conocer todas las funcionalidades
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <Calendar className="text-blue-400 mx-auto mb-4" size={48} />
              <h3 className="text-white font-bold text-lg mb-2">Implementación Rápida</h3>
              <p className="text-blue-100 text-sm">
                Tu sistema estará funcionando en menos de 24 horas
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <Phone className="text-purple-400 mx-auto mb-4" size={48} />
              <h3 className="text-white font-bold text-lg mb-2">Soporte 24/7</h3>
              <p className="text-blue-100 text-sm">
                Equipo de expertos disponible cuando lo necesites
              </p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col lg:flex-row gap-6 justify-center items-center mb-16">
            <Button 
              size="lg" 
              className="bg-white text-blue-900 hover:bg-blue-50 px-10 py-6 text-xl font-bold shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300"
            >
              Solicitar Demo Gratuita
              <ArrowRight className="ml-3" size={24} />
            </Button>
            
            <div className="flex items-center space-x-4 text-white">
              <span className="text-lg">o llámanos:</span>
              <a 
                href="tel:+1234567890" 
                className="flex items-center space-x-2 text-2xl font-bold hover:text-blue-200 transition-colors"
              >
                <Phone size={24} />
                <span>+1 (234) 567-890</span>
              </a>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="border-t border-white/20 pt-12">
            <p className="text-blue-100 mb-8 text-lg">
              Empresas de todos los tamaños confían en SAIP
            </p>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center opacity-60">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-white">1000+</div>
                <div className="text-blue-200 text-sm">Empresas</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-white">99.9%</div>
                <div className="text-blue-200 text-sm">Uptime</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-white">24h</div>
                <div className="text-blue-200 text-sm">Implementación</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-white">4.9★</div>
                <div className="text-blue-200 text-sm">Satisfacción</div>
              </div>
            </div>
          </div>

          {/* Contact Options */}
          <div className="mt-16 bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <h3 className="text-2xl font-bold text-white mb-6">
              ¿Prefieres que te contactemos nosotros?
            </h3>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="text-center">
                <Mail className="text-blue-300 mx-auto mb-3" size={32} />
                <h4 className="text-white font-semibold mb-2">Email</h4>
                <a 
                  href="mailto:ventas@reset.com" 
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  ventas@reset.com
                </a>
              </div>
              
              <div className="text-center">
                <Calendar className="text-green-300 mx-auto mb-3" size={32} />
                <h4 className="text-white font-semibold mb-2">Agenda una Reunión</h4>
                <Button variant="outline" className="text-white border-white/30 hover:bg-white/10">
                  Reservar Cita
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;